import { Link } from 'react-router-dom';
import globalStyles from './App.module.scss';
import BackArrow from './assets/back-arrow.svg';

export interface BackLinkProps {
    destination: string;
}

function BackLink({ destination }: BackLinkProps) {
    return (
        <div className={globalStyles.backLink}>
            <Link to={destination}>
                <img src={BackArrow} alt="" />
                Tilbake
            </Link>
        </div>
    );
}

export default BackLink;
